import gql from 'graphql-tag';

export default gql`
query getPageNamesBySlugPaths($slugPaths: [String!]!) {
  item_lookup(where: {slug_path: {_in: $slugPaths}, page_id: {_is_null: false}}) {
    slug_path
    page { name }
  }
}
`;
